"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
import type { JobadComponentProps } from "~/types/job";
const colConfig = {
  intGraduate: "md:columns-1",
  default: "md:columns-2"
};
export default function Company(t0) {
  const $ = _c(9);
  const {
    job
  } = t0;
  const validIds = ["230421", "232072", "232073", "232074", "232075", "232076", "232078", "232079", "232081", "232083"];
  const isIntGraduate = validIds.includes(job.data.idClient);
  const cols = isIntGraduate ? colConfig.intGraduate : colConfig.default;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      backgroundImage: `url(${process.env.NEXT_PUBLIC_ASSET_URL}images/jobad/company-bg.webp)`,
      backgroundSize: "cover",
      backgroundPosition: "right"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== job.data.company) {
    t2 = <h2 className="md:!text-5xl mb-10 font-bold print:text-lg" data-source="job">{job.data.company}</h2>;
    $[1] = job.data.company;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== cols || $[4] !== job.content.business) {
    t3 = job.content.business && <div className={cn("gap-20 text-lg [&>p]:mb-4", cols)} dangerouslySetInnerHTML={{
      __html: job.content.business
    }} data-source="job" />;
    $[3] = cols;
    $[4] = job.content.business;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <section className="outer-container py-container text-white" id="company" style={t1}><div className="inner-container"><div>{t2}{t3}</div></div></section>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}